export class AutoReleaseResult {
	public success: boolean;
	public locations: Array<{ contractLocationId: string; hasSampleBill: boolean; hasLOA: boolean; hasLOE: boolean }>;
	public errors: string[];
	public sampleBillCheckPassed: boolean;
	public usageCheckPassed: boolean;
	public effectiveDateCheckPassed: boolean;
	public loaCheckPassed: boolean;
	public loeCheckPassed: boolean;
	public bufferMarginCheckPassed: boolean;
	public sampleBillRequestDate?: Date;
	public loaRequestDate?: Date;
	public loeRequestDate?: Date;
	public missingDocuments: string[];
	public invalidDocuments: string[];

	constructor(autoReleaseResult: AutoReleaseResult) {
		Object.assign(this, autoReleaseResult);
	}
}
